// src/components/layouts/PublicLayout.tsx
import React from "react";
import { Outlet } from "react-router-dom";
import PostHogPageViewTracker from "../analytics/PostHogPageViewTracker";

export default function PublicLayout() {
    return (
        <div className="h-full bg-gray-100">
            <PostHogPageViewTracker />
            <Outlet />
        </div>
    );
}
